<template>
  <div class="button-container">
    <div class="form-checkbox accept-terms">
      <input
        class="checkbox"
        type="checkbox"
        id="accept-terms"
        @click="checkRegulation"
      />
      <label for="accept-terms" class="checkbox"
        ><span>{{ $t("common.agreeToTerms") }}</span></label
      >
    </div>

    <div style="width: 95%; margin: auto">
      <!-- チケット内容を確認ボタン -->
      <ItemButton
        :icon="icon"
        :label="label"
        :isDisabled="isDisabled"
        :actionType="actionType"
        @clicked="goToNextPage"
      />

      <!-- キャンセルボタン -->
      <ItemButton
        :label="$t('common.cancelButtonLabel')"
        actionType="btn-cancel"
        @clicked="backToBeforePage"
      />
    </div>
  </div>
</template>

<script>
import { watchEffect, ref, props, SetupContext } from "vue";

export default {
  name: "TheStickyMenu",
  props: {
    icon: String,
    label: String,
    // 必要な情報が入力済みかどうか(入力済みならfalse)
    isSubmitDisabled: Boolean,
  },
  setup(props, context) {
    const actionType = ref("disabled");
    const isChecked = ref(false);
    const isDisabled = ref(true);

    const checkRegulation = () => {
      var ele = document.getElementsByClassName("checkbox")[0];
      isChecked.value = ele.checked;
    };

    watchEffect(() => {
      if (isChecked.value && !props.isSubmitDisabled) {
        actionType.value = "btn-primary";
        isDisabled.value = false;
      } else {
        actionType.value = "disabled";
        isDisabled.value = true;
      }
    });

    const goToNextPage = () => {
      context.emit("clicked");
    };

    const backToBeforePage = () => {
      context.emit("cancelClicked");
    };

    return {
      actionType,
      isDisabled,
      checkRegulation,
      goToNextPage,
      backToBeforePage,
    };
  },
};
</script>

<style lang="scss" scoped>
.button-container {
  padding: 50px 0;
}

.button-container .accept-terms {
  margin: 0 0 15px 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}

.button-container button {
  width: calc(100% - 30px);
  margin: auto;
}
</style>
